const module = {
  namespaced: true,
  state: {
    main: null
  },
  mutations: {
    setMainDrawer: (state, v) => {
      state.main = v
    }
  }
}

export default module
